import { Pipe, PipeTransform } from '@angular/core';
import { LabelTransformService } from 'src/app/services/label-transform.service';

@Pipe({ name: 'replaceLabel'})
export class ReplaceLabelPipe implements PipeTransform {
  constructor(private labelService: LabelTransformService) {}
  transform(value: string): string {
    return this.labelService.replace(value);
  }

}
